'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _Calendar = require('../../../blocks/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _P = require('../../../elements/P');

var _P2 = _interopRequireDefault(_P);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: Determine a way to implement translations
var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

var DateGrid = function (_Component) {
  _inherits(DateGrid, _Component);

  function DateGrid() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateGrid.__proto__ || Object.getPrototypeOf(DateGrid)).call.apply(_ref, [this].concat(args))), _this), _this.isDateDisabled = function (disabledDates, dateToTest) {
      return !!((0, _utils.isBeforeDate)(disabledDates.before, dateToTest) || (0, _utils.isAfterDate)(disabledDates.after, dateToTest));
    }, _this.isDateInRange = function (selectedDateRange, hoveredOverDate, dateToTest) {
      return !!(selectedDateRange.from && (selectedDateRange.to && (0, _utils.isBetweenDates)(selectedDateRange.from, selectedDateRange.to, dateToTest) || hoveredOverDate && (0, _utils.isBetweenDates)(hoveredOverDate, selectedDateRange.from, dateToTest)) || !selectedDateRange.to && hoveredOverDate && (0, _utils.isBetweenDates)(selectedDateRange.from, hoveredOverDate, dateToTest));
    }, _this.isDateSelected = function (date) {
      return !!(_this.props.range && ((0, _utils.isSameDate)(date, _this.props.selectedDateRange.from) || (0, _utils.isSameDate)(date, _this.props.selectedDateRange.to)) || !_this.props.range && (0, _utils.isSameDate)(date, _this.props.selectedDate));
    }, _this.handleSelectDate = function (date) {
      if (_this.isDateSelected(date)) {
        _this.props.onSelectDate(null, date);
      } else {
        _this.props.onSelectDate(date, date);
      }
    }, _this.isBuildingToday = function (date) {
      return !!(_this.props.today.year === _this.props.displayMonth.year && _this.props.today.month === _this.props.displayMonth.month && _this.props.today.date === date);
    }, _this.buildDate = function (date, index) {
      var jsDate = new Date(_this.props.displayMonth.year, _this.props.displayMonth.month - 1, date);

      var dateTableCellModifiers = (0, _lodash.compact)([date && 'withBorder']);

      var dateDisabled = _this.isDateDisabled(_this.props.disabledDates, jsDate);
      var dateInRange = _this.props.range && _this.isDateInRange(_this.props.selectedDateRange, _this.props.hoveredOverDate, jsDate);
      var dateSelected = _this.isDateSelected(jsDate);

      var dateModifiers = (0, _lodash.compact)([dateDisabled && 'disabled', dateInRange && 'inRange', dateSelected && 'selected']);

      return _react2.default.createElement(
        _Calendar2.default.DateTableCell,
        {
          key: 'dayIndex-' + index,
          modifiers: dateTableCellModifiers
        },
        date && _react2.default.createElement(
          _Calendar2.default.Date,
          {
            disabled: dateDisabled,
            modifiers: dateModifiers,
            onMouseEnter: function onMouseEnter() {
              return !dateDisabled && _this.props.updateHoveredOverDate(jsDate);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.props.updateHoveredOverDate(null);
            },
            onClick: function onClick() {
              return _this.handleSelectDate(jsDate);
            }
          },
          _react2.default.createElement(
            'div',
            null,
            date
          ),
          _react2.default.createElement(
            'div',
            null,
            _this.isBuildingToday(date) && _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
          )
        )
      );
    }, _this.buildWeek = function (week, index) {
      return _react2.default.createElement(
        _Calendar2.default.DateTableRow,
        { key: 'week-' + index },
        week.map(function (date, dateIndex) {
          return _this.buildDate(date, dateIndex);
        })
      );
    }, _this.buildWeeks = function (displayMonth) {
      // This gets the index of the first of the month within the first week. Ex, if the first is a
      // Wednesday, the firstDayIndex will be 4.
      var firstDayIndex = (0, _utils.getFirstDayOfMonthIndex)(displayMonth);

      // This creates an incrementing array the length of the days in the month
      // plus the days in the first week that are not a part of this month.
      var daysInCalendar = [].concat(_toConsumableArray(Array(displayMonth.daysInMonth + firstDayIndex).keys()));

      // Converts array the length of the total days in the calendar into an array of weeks with
      // properly indexed dates.
      return daysInCalendar.reduce(function (acc, index) {
        // Evaluates the index to determine if this should be the start of a new week.
        var buildingNewWeek = index % 7 === 0;

        // Evaluates whether the current index refers to one of the days before this month begins
        var buildingCurrentMonth = firstDayIndex <= index;

        // Creates the correct date for this index, or null
        var dateVal = buildingCurrentMonth ? index - firstDayIndex + 1 : null;

        // If the current index is the first in the week, adds a new array with the correct date at
        // index 0
        if (buildingNewWeek) {
          var newWeek = [dateVal];
          return [].concat(_toConsumableArray(acc), [newWeek]);
        }

        // If the current index is not the first in the week, appends the correct date to the last
        // week array.
        acc[acc.length - 1].push(dateVal);
        return acc;
      }, []);
    }, _this.buildDateTable = function () {
      return _react2.default.createElement(
        _Calendar2.default.DateTable,
        null,
        _react2.default.createElement(
          'tbody',
          null,
          _this.buildWeeks(_this.props.displayMonth).map(function (week, index) {
            return _this.buildWeek(week, index);
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Evaluates whether the provided date falls within a disabled date range (provided via props)
   * @param    {Object}  disabledDates        Contains data concerning the dates to be disabled.
   * @property {Date}    disabledDates.before All dates before this date are disabled.
   * @property {Date}    disabledDates.after  All dates after this date are disabled.
   * @param    {Date}    dateToTest           The date to test
   * @return   {Boolean}
   */


  /**
   * Evaluates whether the provided date is between two selected dates, or between the selected
   * date and the currently hovered over date.
   * @param    {Object}  selectedDateRange        Contains data concerning the dates to be disabled.
   * @property {Date}    selectedDateRange.from   All dates before this date are disabled.
   * @property {Date}    selectedDateRange.to     All dates after this date are disabled.
   * @param    {Date}    hoveredOverDate          The date the cursor is currently over.
   * @param    {Date}    dateToTest               The date to test
   * @return   {Boolean}
   */


  /**
   * Evaluates whether the provided date is one of the currently selected dates.
   * @param  {Date}    date The date to test
   * @return {Boolean}
   */


  /**
   * Handles the click event on a date. Calls `onSelectDate` from props with the args,
   * [newSelectedDate, dateClicked]
   * @param  {Date} date The date that was clicked
   */


  /**
   * Evaluates whether the date currently being built is today. Time doesn't matter.
   * @param  {Date}    date The date to test
   * @return {Boolean}
   */


  /**
   * Builds a single, correctly styled date for display within the calendar grid.
   * @param  {Number}    date  The date number in the month to build. Ex, the first would be 1.
   * @param  {Number}    index The index of the date within the week. Ex, Sunday would be 0.
   * @return {Component} A fully built JSX DateTableCell, ready to render.
   */


  /**
   * Builds a single row for display within the calendar grid.
   * @param  {Array<Number>} week  An array of numbers, representing the dates to display in the
   *                               week.
   * @param  {Number}        index The index of the week within the month.
   * @return {Component} A fully built JSX DateTableRow, ready to render.
   */


  /**
   * Evaluates the provided displayMonth to determine how many weeks the month spans, and what
   * position within those weeks the dates should be in.
   * @param    {Object} displayMonth             a displayMonth Object
   * @property {Number} displayMonth.daysInMonth the total number of days in this month
   * @return {Array<Array>} An array of arrays representing the weeks the month touches populated
   * with the dates in the correct indexes. `null` is present for indexes that do not correspond to
   * dates for this month.
   */


  /**
   * Builds a calendar grid for display.
   * @return {Component} A fully built JSX DateTable, ready to render.
   */


  _createClass(DateGrid, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          DAYS.map(function (day) {
            return _react2.default.createElement(
              _styledComponentsReactiveGrid.Column,
              { key: day, modifiers: ['center', 'col', 'padScale_0'] },
              _react2.default.createElement(
                _P2.default,
                { modifiers: ['small'] },
                day
              )
            );
          })
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          this.buildDateTable()
        )
      );
    }
  }]);

  return DateGrid;
}(_react.Component);

DateGrid.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  displayMonth: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    daysInMonth: _propTypes2.default.number.isRequired
  }).isRequired,
  hoveredOverDate: _propTypes2.default.instanceOf(Date),
  onSelectDate: _propTypes2.default.func.isRequired,
  range: _propTypes2.default.bool,
  selectedDate: _propTypes2.default.instanceOf(Date),
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  today: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    date: _propTypes2.default.number.isRequired
  }).isRequired,
  updateHoveredOverDate: _propTypes2.default.func.isRequired
};
DateGrid.defaultProps = {
  disabledDates: {},
  hoveredOverDate: null,
  range: false,
  selectedDate: null,
  selectedDateRange: {}
};
exports.default = DateGrid;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/DateSelectors/DateGrid/index.js
// module id = 1638
// module chunks = 2